export function isTaxMarked(param) {
    let { ownMark, childMarks } = param;
    return childMarks.length === 0 ? ownMark : childMarks.includes(true);
}
export function isPartiallyTaxable(param) {
    let { childMarks } = param;
    const markedCount = childMarks.filter(Boolean).length;
    return markedCount > 0 && markedCount < childMarks.length;
}
